import React, { useEffect, useState } from "react";
import "../FeedbackPopUp/feedbackPopup.css";






import CloseButton from "../../Images/closeButton.svg";
import apiService from "../../Services/apiServices";






function R1FeedBack({ data, setIsFeedbackPop, showMaximumChat, sessionId, setCheckThumsDownFeedback, messages, index, checkThumsDownFeedback, setShowR1FeedbackPop, addMessagesFeedback, flow ,showR1FeedbackPop }) {

    const extractedData = JSON.parse(data?.data)
    const feedbackOptions = showR1FeedbackPop?.option === 'up' ? extractedData?.thumnsUpFeedbackOptions : extractedData?.thumnsDownFeedbackOptions



    const [selectedItem, setSelectedItem] = useState({});
    const [submitButtonDisable, setSubmitButtonDisable] = useState(true);
    const [thankYouNote, setThankYouNote] = useState(false);
    const [activeOption, setActiveOption] = useState(null);
    const [feedBackInput, setFeedBackInput] = useState('');

    const [selectedOptions, setSelectedOptions] = useState({});


    useEffect(() => {

        setFeedBackInput((prevState) => {
            console.log("Previous feedBackInput:", prevState);
            return ''; 
        });
        setSelectedOptions({});
        setSubmitButtonDisable(true);
    }, [showR1FeedbackPop?.option]);

    

    const handleClick = (optionId) => {
        setSelectedOptions((prevState) => {
            const newSelectedOptions = { ...prevState };
            if (newSelectedOptions[optionId]) {
                delete newSelectedOptions[optionId];
            } else {
                newSelectedOptions[optionId] = true;
            }
            setSubmitButtonDisable(Object.keys(newSelectedOptions).length === 0);
            return newSelectedOptions;
        });
    };



    const handleSubmitButton = () => {
        // document.querySelector('.animated-popup').classList.add('hide');

        setCheckThumsDownFeedback([...checkThumsDownFeedback, index]);

        let n = document.getElementsByClassName("thums-button");
        for (let i = 0; i < n.length; i++) {
            n[i].disabled = true;
            n[i].style.cursor = "not-allowed";
            n[i].style.pointerEvents = "none";
        }

        const optionsSelected = feedbackOptions
            .filter((item) => selectedOptions[item.id])
            .map((item) => item.name);

            
        const inputFeedback = {
            feedbackThumbs: showR1FeedbackPop?.option === 'up' ? 'Thumbs Up' : 'Thumbs Down',
            feedbackOptions: optionsSelected,
            feedbackResponse: encodeURIComponent(
                feedBackInput 
              ),
            flowName: flow
        };

        // Store timeouts
        // const timeout1 = setTimeout(() => {
        setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
        // }, 300);

        // const timeout2 = setTimeout(() => {
            addMessagesFeedback(showR1FeedbackPop?.option === 'up' ? 'Thumbs Up' : 'Thumbs Down', data?.code, null, null, null, inputFeedback);
        // }, 500);

        // Cleanup function to clear timeouts
        return () => {
            // clearTimeout(timeout1);
            // clearTimeout(timeout2);
        };
    };


    const maximum = () => {
        return (
            <div>
                <div className="feedback-overlay"></div>

                <div className="feedback-popup">
                    {/* /top */}
                    <div className="feedback-popup-header">
                        <span className="popup-row-one">
                            <div className="popup-help">{extractedData?.header}</div>
                            <img
                                src={CloseButton}
                                onClick={() => setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }))}
                                style={{
                                    position: "absolute",
                                    width: "24px",
                                    height: "24px",
                                    top: "18px",
                                    right: "10px",
                                }}
                            ></img>
                        </span>
                        <span className="popup-sub">
                            {extractedData?.para}
                        </span>
                    </div>

                    {/* middle */}
                    <div className="feedback-popup-content">
                        <div className="feedback-popup-options">
                            <div
                                className="feedback-popup-option"
                                style={{
                                    display: "flex",
                                    flexWrap: 'wrap',
                                    gridTemplateColumns: "1fr 1fr",
                                    gridColumnGap: "8px",
                                    gridRowGap: "14px",
                                    border: "1px",
                                    borderRadius: "4px",
                                }}
                            >
                                {feedbackOptions?.map((option) => (
                                    <button
                                        key={option.id}
                                        className={`feedback-button ${selectedOptions[option.id] ? "active" : ""
                                            }`}
                                        onClick={() => handleClick(option?.id)}
                                    >
                                        {/* <img src={option?.src} alt={option?.name} className="icon" /> */}
                                        <span style={{ color: '#220046' }}>{option?.name}</span>
                                    </button>
                                ))}
                            </div>
                            <div className="feedback-popup-comment">
                                <div className="feedback-res">
                                    {extractedData?.textBoxHeader}
                                </div>
                                <input
                                    style={{
                                        width: "568px",
                                        borderRadius: "4px",
                                        height: "37.6px",
                                        boxSizing: "border-box",
                                        padding: "10px",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                    onChange={(e) => setFeedBackInput(e?.target?.value)}
                                    placeholder="Write your feedback..."
                                ></input>
                            </div>
                        </div>
                    </div>

                    {/* bottom */}
                    <div className="feedback-popup-footer">
                        <div className="feedback-popup-button">
                            <button
                                className="feedback-btn-submit"
                                type={"submit"}
                                onClick={() => handleSubmitButton()}
                                disabled={submitButtonDisable}
                            >
                                Submit
                            </button>
                            <button
                                className="feedback-btn-cancel"
                                onClick={() => setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }))}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    const minimumChat = () => {
        return (
            <div
                className="animated-popup"
                style={{
                    width: "90%",
                    border: "1px solid #E1E1E1",
                    borderRadius: "8px",
                    marginTop: "12px",
                    marginLeft: "36px",
                    boxShadow: '0px 4px 10px rgba(225, 137, 231, 0.5)'
                }}
            >

                <>
                    <div style={{ width: "90%" }} className="feedback-popup-header">
                        <span className="popup-row-one-mini">
                            <div className="popup-help">{extractedData?.header}</div>
                            {/* <img src={CloseButton} onClick={() => setIsFeedbackPop(false)}
                      style={{ height: '24px', top: '18px', right: '10px' }}
                  ></img> */}
                        </span>
                        <span className="popup-sub">
                            {extractedData?.para}
                        </span>
                    </div>

                    <div style={{ width: "90%" }} className="feedback-popup-content">
                        <div className="feedback-popup-options">
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "16px",
                                    border: "1px #E1E1E1",
                                    borderRadius: "4px",
                                    width: "100%",
                                    paddingBottom: "10px",
                                    marginTop: "16px",
                                }}
                            >
                                {feedbackOptions?.map((option) => (
                                    <button
                                        key={option.id}
                                        className={`feedback-button ${selectedOptions[option.id] ? "active" : ""
                                            }`}
                                        onClick={() => handleClick(option?.id)}
                                    >
                                        {/* <img src={option?.src} alt={option?.name} className="icon" /> */}
                                        <span style={{ color: '#220046' }}>{option?.name}</span>
                                    </button>
                                ))}
                            </div>
                            <div className="feedback-popup-comment">
                                <div className="feedback-res">
                                    {extractedData?.textBoxHeader}
                                </div>
                                <input
                                    style={{
                                        width: "100%",
                                        borderRadius: "4px",
                                        height: "37.6px",
                                        boxSizing: "border-box",
                                        padding: "10px",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={feedBackInput} // Controlled input
                                    onChange={(e) => {
                                        setFeedBackInput(e.target.value);
                                    }}
                                    placeholder="Write your feedback..."
                                ></input>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: "70px" }} className="feedback-popup-footer">
                        <div className="feedback-popup-button">
                            <button
                                className="feedback-btn-submit"
                                type="submit"
                                onClick={() => handleSubmitButton()}
                                disabled={submitButtonDisable}
                            >
                                Submit
                            </button>
                            <button
                                className="feedback-btn-cancel"
                                onClick={() => {
                                    setShowR1FeedbackPop((prevState) => ({ ...prevState, isActive: false }));
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </>

            </div>
        );
    };

    return <>{showMaximumChat ? maximum() : minimumChat()}</>;
}

export default R1FeedBack;
